import { render } from "./SectionNavNoMenu.vue?vue&type=template&id=50be4168&scoped=true"
import script from "./SectionNavNoMenu.vue?vue&type=script&lang=js"
export * from "./SectionNavNoMenu.vue?vue&type=script&lang=js"

import "./SectionNavNoMenu.vue?vue&type=style&index=0&id=50be4168&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50be4168"

export default script